import { useTranslation } from 'react-i18next';
import HeaderTemplate from 'components/Templates/Header/HeaderTemplate';
import { FC } from 'react';
import { Container, Box } from './PrivacyStatement.styled';
import PrivacyStatementContent from 'components/PrivacyStatement/PrivacyStatementContent';

const PrivacyStatement: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderTemplate sectionName={t('general.header.menu.privacy-statement')} />
      <Container>
        <Box my={5}>
          <PrivacyStatementContent />
        </Box>
      </Container>
    </>
  );
};

export default PrivacyStatement;
